export default __webpack_public_path__ + "static/sentrydefault_1280x720-e61073c901b764f3779badafb3d8bba8.jpg";